import { Link, useParams } from "react-router-dom";
import { FETCH_WAREHOUSE_ITEMS_V2 } from "../../../../graphql/query/WarehouseItem";
import { Table } from "../../../../components/Functional";

const Label = props => {
  const { label, widthInPx = 200, disabled = false } = props || {};
  return (
    <div
      title={label}
      className={`overflow-hidden text-ellipsis text-base font-medium leading-5 ${disabled ? "text-gray-400" : "text-black"}`}
      style={{ maxWidth: `${widthInPx}px` }}
    >
      {label}
    </div>
  );
};

const Container = () => {
  const { id } = useParams();

  const tableProps = {
    variant: "dynamicHeight",
    dataKey: "warehouseItemsV2",
    headers: [
      {
        label: "Item",
        name: "id",
        type: "custom",
        component: ({ values }) => {
          const isDisabled = values.destroyed === -1;
          return (
            <Link
              className={`underline ${isDisabled ? "pointer-events-auto text-gray-400" : ""}`}
              to={`/warehouse/${values?.id}/details`}
            >
              {values?.id}
            </Link>
          );
        },
      },
      {
        label: "Group",
        name: "mgroup",
        type: "custom",
        component: ({ values }) => (
          <Label label={values.mgroup} disabled={values.destroyed === -1} />
        ),
      },
      {
        label: "Category",
        name: "category.description",
        type: "custom",
        component: ({ values }) => (
          <Label
            label={values.category?.description}
            disabled={values.destroyed === -1}
          />
        ),
      },
      {
        label: "Description",
        name: "description",
        type: "custom",
        component: ({ values }) => (
          <Label
            label={values.itemDescription || values.description}
            disabled={values.destroyed === -1}
          />
        ),
      },
      {
        label: "Weight (Kg)",
        name: "weight",
        type: "custom",
        component: ({ values }) => (
          <Label label={values.weight} disabled={values.destroyed === -1} />
        ),
      },
      {
        label: "Dimensions",
        type: "custom",
        component: ({ values }) => (
          <Label
            label={`${values.dimh ?? "00"}L ${values.dimw ?? "00"}W ${
              values.dimd ?? "00"
            }H`}
            disabled={values.destroyed === -1}
          />
        ),
      },
      {
        label: "Site",
        type: "custom",
        component: ({ values }) => (
          <Label
            label={values.itemSite?.site?.name}
            disabled={values.destroyed === -1}
          />
        ),
      },
      {
        label: "Location",
        type: "custom",
        component: ({ values }) => (
          <Label
            label={values.itemSite?.location?.description}
            disabled={values.destroyed === -1}
          />
        ),
      },
    ],
    inputs: [],
    FETCH_QUERY: FETCH_WAREHOUSE_ITEMS_V2({
      destroyed: true,
      mgroup: true,
      itemDescription: true,
      description: true,
      weight: true,
      dimh: true,
      dimw: true,
      dimd: true,
      category: {
        description: true,
      },
      itemSite: {
        site: {
          name: true,
        },
        location: {
          description: true,
        },
      },
    }),
    variables: {
      container: { value: id, operator: "eq" },
    },
    rowClassName: row => {
      return row.destroyed === -1 ? "opacity-50" : "";
    },
    className: "sm:px-0 lg:px-0",
  };

  return (
    <div className="min-h-full">
      <h2 className="ml-9 mt-3 font-bold">Container {id}</h2>
      <div className="flex w-full">
        <div className="flex-1">
          <Table {...tableProps} />
        </div>
      </div>
    </div>
  );
};

export default Container;
